(() => {
 function init(root = document) {
  root.querySelectorAll('[data-avgar-product]').forEach(product => {
   if(product.dataset.initialized) return;
   product.dataset.initialized = 'true';
   const input = product.querySelector('[name="quantity"]');
   product.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
    const direction = Number(button.dataset.quantityChange);
    if(direction > 0) input.stepUp(); else input.stepDown();
    input.dispatchEvent(new Event('change', {bubbles:true}));
   }));
   product.querySelector('[data-avgar-variant]')?.addEventListener('change', event => {
    // Server rendering keeps market prices, availability and accelerated checkout consistent.
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.toString());
   });
  });
 }
 init();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
